import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default class AdminA11yReportsA11yReportRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ a11y_report_id }) {
    const { content } = await this.store.request(
      findRecord('a11y-report', a11y_report_id),
    );

    return content.data;
  }

  afterModel(model) {
    // We need to register a custom explorer route to set the queryParams
    this.breadcrumb.registerExplorerRoute(getRecordType(model), {
      queryParams: { scan: model.scan.id },
    });

    this.breadcrumb.registerDetailRoute(model);
  }
}
